;function fillZero(number) {
  number = Number(number);
  if (number < 10) {
    number = '00'+number;
  } else if (number < 100) {
    number = '0'+number;
  }
  return number;
}
